import type { SmartyAutoCompleteResponse } from 'api/smarty/smarty.types';
import { isEmpty, isUndefined } from 'lodash-es';

/**
 * Formats the selected option for second request with entries.
 *
 * @param {SmartyAutoCompleteResponse} selectedOption - The selected option to format.
 * @param {boolean} [includeEntries=false] - Whether to include the number of entries in the formatted string.
 * @returns {string} The formatted string.
 */
export const formatSelectedSmartyOptionWithEntries = (
  selectedOption: SmartyAutoCompleteResponse,
  includeEntries: boolean = false,
): string => {
  const streetLine = selectedOption?.street_line || '';
  const secondary = !isEmpty(selectedOption?.secondary) ? ` ${selectedOption.secondary}` : '';
  const entries =
    includeEntries && !isUndefined(selectedOption?.entries) ? ` (${selectedOption?.entries})` : '';
  const city = selectedOption?.city || '';
  const state = selectedOption?.state || '';
  const zipcode = selectedOption?.zipcode || '';

  return `${streetLine}${secondary}${entries} ${city}, ${state} ${zipcode}`;
};
